import withNoindex from "../components/seo/with-noindex"

export default withNoindex(require("../templates/Register").default, "Cadastro")
